export class NativeStreamStructOutputField {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "type",
            "baseName": "type",
            "type": "NativeStreamStructOutputKind",
            "format": ""
        },
        {
            "name": "fields",
            "baseName": "fields",
            "type": "Array<NativeStreamOutputField>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return NativeStreamStructOutputField.attributeTypeMap;
    }
    constructor() {
    }
}
